// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import VeroNavbar from "components/VeroNavbar";
import VeroFooter from "components/VeroFooter";

// Vero Software examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Routes
import routes from "routes";

// Images
import BobImage from "assets/images/bob-LeRoy .jpeg";
import LynnImage from "assets/images/lynn-leroy.jpeg";

function History() {
  return (
    <MKBox>
      <VeroNavbar routes={routes} />
      <MKBox component="section" py={6}>
        <Container>
          <Grid container justifyContent="center" textAlign="center" mb={4}>
            <Grid item xs={12} md={8}>
              <MKTypography variant="h3" mb={1}>
                History
              </MKTypography>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10}>
              <MKTypography variant="body1" color="text" mb={2}>
                We started our journey back in 1998. It was on a family vacation that we decided
                it was time to try this. The first question was &quot;what should we call it?&quot;
                Since we were on the beach in Vero, Florida, it made sense to use that name. So,
                Vero Software was born.
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={2}>
                Our first client came from a neighbor who was an operations manager. Vero was put
                on the back burner for a while as we both had full-time jobs and kids to raise
                &mdash; though we always kept a couple of small clients going on the side.
              </MKTypography>
              <MKTypography variant="body1" color="text" mb={2}>
                It was during the pandemic that we decided to give it a go again. We started with
                a handful of clients and have grown from there. Vero is a small company of two
                principals, but we draw on a wider network of experts to meet client needs as
                they come up.
              </MKTypography>

              <Grid container spacing={3} mt={2}>
                <Grid item xs={12} md={6}>
                  <HorizontalTeamCard
                    image={BobImage}
                    name="Bob LeRoy"
                    position={{ color: "info", label: "Chief Engineering Officer" }}
                    description="Bob does the software development, cloud, data analytics, and AI/ML work."
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <HorizontalTeamCard
                    image={LynnImage}
                    name="Lynn LeRoy"
                    position={{ color: "info", label: "Chief Client Officer" }}
                    description="Lynn makes sure the clients are happy, the bills are paid, and Vero grows."
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <VeroFooter />
    </MKBox>
  );
}

export default History;
